import React from 'react';
import {Button, Drawer} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/pro-solid-svg-icons'
import './mobile-menu.css';
// import {MainMenu} from './main-menu';
import {MainMenu} from '../../routers/router-principal';

class MobileMenu extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            visible: false
        }
    }

    onClose = () => {
        const visible = false;
        this.setState({visible})
    }

    openMenu = () => {
        const visible = true;
        this.setState({visible})
    }

    render = () => {
        return (
            <div className='mobile-menu-wrapper'>
                <Button className='mobile-menu-button' type='primary' onClick={this.openMenu}>
                    
                    <FontAwesomeIcon icon={faBars} />
                    
                </Button>
                <Drawer
                    title="Menu"
                    placement='left'
                    closable={true}
                    onClose={this.onClose}
                    visible={this.state.visible}
                    key='mobile-menu'
                >
                    <MainMenu></MainMenu>
                </Drawer>
            </div>
        )
    }
}

export {MobileMenu};